<template>
  <div class="xl:flex">
    <Nav class="w-full xl:w-1/6" />
    <div class="loyalty-programme-content text-left flex-1 w-full xl:w-5/6">

      <Spinner v-if="loyaltyStore.loading" />
      <template v-else>
        <img v-if="headerBannerUrl" :src="headerBannerUrl" alt="header-banner" />
        <ProgressBar :loyalty-user="loyaltyStore.user" :loyalty-tiers="loyaltyStore.tiers" />

        <div v-for="tier in loyaltyStore.tiers"
          :key="tier.id"
          class="tier-container mb-5"
        >
          <p :class="['tier-title text-lg font-semibold uppercase mb-2', { 'transparent': !isTierReached(tier) }]">{{tier.name[$i18n.locale]}}</p>
          <div class="flex flex-col sm:flex-row items-end">
            <div :class="['tier-grid grid grid-cols-2 gap-4 sm:grid-cols-4 sm:gap-4', { 'transparent': !isTierReached(tier) }]">
              <div v-for="(reward, index) in tier.rewards.slice(0, visibleRewardsCounts[tier.id])"
                :key="reward.id"
                :data-reward-id=reward.id
              >
                <RewardBox :reward="reward" :color="`#fcd34d`" :favourite="isUserFavourite(reward)" :show-link="isTierReached(tier)" />
              </div>
            </div>

            <div class="more-rewards ml-0 sm:ml-2 w-1/6 w-full sm:w-auto text-center sm:text-left text-sm">
              <!-- desktop "more..." -->
              <a v-if="tier.rewards.length > visibleRewardsCounts[tier.id]"
                 class="hidden sm:block"
                 href="javascript:"
                 @click="visibleRewardsCounts[tier.id] = tier.rewards.length">{{t('loyalty-programme.more')}}...
              </a>

              <!-- mobile "more/less" buttons -->
              <a v-if="visibleRewardsCounts[tier.id] < tier.rewards.length"
                 class="more-button block sm:hidden px-4 py-1.5 mt-3.5 mx-32 bg-transparent hover:bg-black hover:text-white border-2 font-bold uppercase rounded-full"
                 href="javascript:"
                 @click="visibleRewardsCounts[tier.id] = tier.rewards.length"
              >
                {{t('loyalty-programme.more')}} <font-awesome-icon icon="chevron-circle-down" size="lg" />
              </a>
              <a v-if="visibleRewardsCounts[tier.id] == tier.rewards.length"
                 class="less-button block sm:hidden px-4 py-1.5 mt-3.5 mx-32 bg-transparent hover:bg-black hover:text-white border-2 font-bold uppercase rounded-full"
                 href="javascript:"
                 @click="visibleRewardsCounts[tier.id] = 4"
              >
                {{t('loyalty-programme.less')}} <font-awesome-icon icon="chevron-circle-up" size="lg" />
              </a>
            </div>
          </div>
        </div>
      </template>

    </div>
  </div>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {computed, ref} from "vue";
import { useTenant } from "@/plugins/tenant";
import RewardBox from "@/components/loyalty-programme/rewardBox.vue";
import ProgressBar from "@/components/loyalty-programme/progressBar.vue";
import axios from "axios";
import Spinner from "@/components/Spinner.vue";
import { useLoyalty } from "@/pinia/loyaltyStore";
import { storeToRefs } from "pinia";
import Nav from "@/pages/loyalty-programme/nav.vue";

const {t} = useI18n();
const tenant = useTenant();
const loyaltyStore = useLoyalty();
const { isUserFavourite, isTierReached } = storeToRefs(loyaltyStore);

const visibleRewardsCounts = ref<{ [key: string]: number }>({});

const headerBannerUrl = tenant.loyaltyConfig?.rewardsHeaderBannerUrl;

async function initialize() {
  await loyaltyStore.fetch();
  loyaltyStore.tiers.forEach(tier => {
    visibleRewardsCounts.value[tier.id] = 4;
  });
}
initialize();

</script>

<style scoped>
  .transparent {
    opacity: 0.5;
  }

  .more-rewards {
    height: 70px;
  }

  .more-button,
  .less-button {
    border-color: #A3A3A3;
  }
</style>
